import { formatDateWithPattern } from "utils/date";
import { unixTimestampToMs } from "utils/time";

const formatChangeHistoryCardEntryTime = (timestamp: number): string => {
  return formatDateWithPattern(unixTimestampToMs(timestamp), "h:mm:ss a");
};

export default formatChangeHistoryCardEntryTime;
